var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseModel from "./BaseModel";
import { filter, find, map, cloneDeep, includes, forEach } from 'lodash';
import RecentItemModel from "./RecentItemModel";
var GroupModel = /** @class */ (function (_super) {
    __extends(GroupModel, _super);
    function GroupModel(data) {
        var _this = _super.call(this, data) || this;
        var hydrated = _super.prototype.useHydrator.call(_this, data);
        _this.id = hydrated.group_id || hydrated.id || 0;
        _this.name = hydrated.name || '';
        _this.options = hydrated.options || [];
        _this.items = [];
        _this.requiredCount = hydrated.required_count || hydrated.requiredCount || 0;
        _this.__mc = 'GroupModel';
        return _this;
    }
    GroupModel.prototype.exportedModel = function (lineItems, base) {
        var exceptionsMap = this.getItemOptionExceptionsMap();
        var filteredOptions = filter(this.options, function (option) {
            var itemIds = map(lineItems, 'id');
            var include = false;
            if (includes(itemIds, option.asset_id)) {
                include = true;
                var lineItem = find(lineItems, function (item) {
                    return item.id === option.asset_id;
                });
                var item_1 = cloneDeep(lineItem);
                var exportItem = item_1.prepareItemForExport(base);
                exportItem['option_exception'] = exceptionsMap[item_1.id];
                var optionExceptionId_1 = null;
                if (exportItem['option_exception']) {
                    optionExceptionId_1 = exportItem['option_exception'].option_id;
                }
                option['lineItem'] = exportItem;
                forEach(exportItem.options, function (option) {
                    if (option.option_id === optionExceptionId_1) {
                        forEach(option.choices, function (choice) {
                            choice['is_master_exception'] = true;
                        });
                    }
                });
                forEach(exportItem.sibs, function (sibItem) {
                    sibItem['option_exception'] = exceptionsMap[item_1.id];
                });
                option['selected'] = true;
                option['parent_asset_id'] = exportItem.parent_asset_id;
            }
            return include;
        });
        return {
            group_id: this.id,
            options: filteredOptions,
        };
    };
    GroupModel.prototype.getItemOptionExceptionsMap = function () {
        var exceptions = {};
        forEach(this.options, function (option) {
            var itemId = option.asset_id;
            var optionException = option.option_exception;
            exceptions[itemId] = optionException;
        });
        return exceptions;
    };
    GroupModel.prototype.hydrate = function (data) {
        var group = {};
        group = data;
        return group;
    };
    GroupModel.prototype.restore = function (lineItems) {
        var _this = this;
        this.items = filter(lineItems, function (item) {
            var groupId = _this.id;
            var itemGroupId = item.parentGroupId;
            return (groupId === itemGroupId);
        });
    };
    GroupModel.prototype.extractLineItems = function () {
        var _this = this;
        var lineItems = [];
        forEach(this.options, function (option) {
            var lineItem = option.lineItem;
            if (lineItem) {
                if (option.free_choices_sets) {
                    lineItem.freeChoices = option.free_choices_sets;
                }
                var cartItem = _this.restoreLineItem(lineItem);
                lineItems.push(cartItem);
            }
        });
        return lineItems;
    };
    GroupModel.prototype.restoreLineItem = function (lineItem) {
        var recentItem = new RecentItemModel(lineItem);
        return recentItem;
    };
    GroupModel.prototype.setupItemInGroup = function (item) {
        var compositeItem = item;
        var groupItem = find(this.options, function (option) {
            return option.asset_id === item.id;
        });
        compositeItem.addFreeChoices(groupItem);
        return compositeItem;
    };
    GroupModel.prototype.hydrateFromStore = function (data) {
        var group = {};
        group = data;
        return group;
    };
    return GroupModel;
}(BaseModel));
export default GroupModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/GroupModel.ts
// module id = Dd+e
// module chunks = 18